import React from 'react'
import "../css/Publication.css";

import ReviewCardSingle from "../components/ReviewCardSingle";
export default function LiteratureReview() {
    return (
        <>
            <div className="publication_lr-about-complete">
                <div className="publication_about_literature_review">
                    {/* <div className="publication_lr-title">Literature Review</div> */}
                    <div
                        className="publication_lr-about"

                    >
                        A literature review is a comprehensive summary and analysis of the
                        existing research on a particular topic. It involves
                        systematically identifying, evaluating, and synthesizing relevant
                        scholarly articles, books, and other sources to provide an
                        overview of current knowledge, identify gaps, and establish the
                        context for new research. The literature review helps to frame the
                        research question, demonstrate the significance of the study, and
                        ensure that the research is built upon a solid foundation of
                        existing work. It is an essential part of academic writing,
                        providing credibility and grounding for the researcher’s own
                        contributions.
                    </div>
                </div>
                {/* <div className="singlepdf">
                    <ReviewCardSingle />
                </div> */}
                
            </div>
            <div className="publication-ka-cards">

						{/* 2025 */}
						<div className="singlepdf">
							<div className="publication_filtered-container">
								<div className="publication_container">
									<div
										className="publication_card publication_skew publication_glow"
										style={{ backgroundImage: "url('/img/Publication/2025.jpg')" }}
									>
										<div className="publication_content">
											{/* <p
												id="publication_paragraph"
												style={{
													textTransform: "uppercase",
													textAlign: "center",
													marginTop:"35%",
													fontSize: "25px",
													marginBottom: "1%",
												}}
											>
											</p> */}

											{/* <p
												id="publication_paragraph"
												style={{ textAlign: "center", textTransform: "uppercase" }}
											>
												2025 RESEARCH PUBLICATION
											</p> */}

											<a
												href="https://drive.google.com/file/d/1TBdErnQOYJuCG0RjRFDikEz50iDEk7jp/view?usp=sharing"
												target="_blank"
												rel="noopener noreferrer"
												style={{
													marginTop:"95%",								
													marginBottom: "1%",
																										
												}}
											>
												Read More
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>

						{/* 2024 */}
						<div className="singlepdf">
							<div className="publication_filtered-container">
								<div className="publication_container">
									<div
										className="publication_card publication_skew publication_glow"
										style={{ backgroundImage: "url('/img/Publication/2024.jpg')" }}
									>
										<div className="publication_content">
											{/* <p
												id="publication_paragraph"
												style={{
													textTransform: "uppercase",
													textAlign: "center",
													marginTop:"35%",
													fontSize: "25px",
													marginBottom: "1%",
												}}
											>
												
											</p> */}

											{/* <p
												id="publication_paragraph"
												style={{ textAlign: "center", textTransform: "uppercase" }}
											>
												2024 RESEARCH PUBLICATION
											</p> */}

											<a
												href="https://drive.google.com/file/d/1DOx33apIQ__0FDzxSUFbBlVBvUU321Se/view"
												target="_blank"
												rel="noopener noreferrer"
												style={{
													marginTop:"95%",								
													marginBottom: "1%",
												}}
											>
												Read More
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
            
        </>
    )
}
